import * as React from "react";
import Dispatcher from "../../Dispatcher";
import LoadObject from "../load_objects/LoadObject";
import LoginStore from "../login/stores/LoginStore";
import RevokeTokenView from "./views/RevokeTokenView";
import { Container } from "flux/utils";
import { ILogin } from "../login/records/Login";

interface IState
{
    loginLoader: LoadObject<ILogin>;
    revokeToken(username, password);
}

class RevokeTokenContainer extends React.Component<{}, IState> {
    public render(): React.ReactElement<any>
    {
        return <RevokeTokenView {...this.state} />;
    }

    public static getStores()
    {
        return [
            LoginStore
        ];
    }

    public static calculateState(prevState): IState
    {
        return {
            loginLoader: LoginStore.getState().getLoadObject(),
            revokeToken: RevokeTokenContainer.revokeToken
        };
    }

    private static revokeToken(username: string, password: string)
    {
        Dispatcher.dispatch({
            type: "login/revoke-token",
            username,
            pwd: password
        });
    }
}

export default Container.create(RevokeTokenContainer);
